import {HttpException} from "./http.exception.js";

/**
 * 400 Bad Request Exception
 */
export class BadRequestException extends HttpException {
    constructor(message: string = "Bad Request", errorBody?: unknown, cause?: Error) {
        super(400, message, errorBody, cause);
    }
}
